<template>
    <div>
        <div class="d-flex align-items-center p-3 my-3 text-rpg-light bg-rpg-primary rounded box-shadow">
            <span class="mr-3"><font-awesome-icon icon="user" size="2x"></font-awesome-icon></span>
            <div class="lh-100 flex-grow-1">
                <h4 class="mb-0 redfont lh-100">{{ $t('create.title') }}</h4>
            </div>
        </div>

        <breadcrumb :items="breadcrumb"></breadcrumb>

        <loading v-if="isLoading && !profile"></loading>
        <profile-form v-model="profile" v-else-if="profile" :species="species" :factions="factions" :genders="genders" :positions="positions" :submit="submit" :button-title="$t('create.send')" :errors="errors"></profile-form>
        <div v-else>
            {{ $t('error.no_data') }}
        </div>
    </div>
</template>

<script>
    import ProfileForm from "../../components/ProfileForm";
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
    import Breadcrumb from "../../components/includes/Breadcrumb";
    import Loading from "../../components/includes/Loading";
    export default {
        name: "ProfileCreate",
        components: {
            Loading,
            ProfileForm,
            FontAwesomeIcon,
            Breadcrumb
        },
        data() {
            return {
                profile: null,
                species: [],
                factions: [],
                genders: [],
                positions: [],
                errors: null
            }
        },
        computed: {
            breadcrumb() {
                return [
                    { route: { name: 'main' }, title: this.$t('title')},
                    { route: { name: 'profile.index' }, title: this.$t('profile.title')},
                    { title: this.$t('create.title') }
                ];
            },

            currentGame () {
                return this.$store.getters['rpg/currentGame'];
            },

            isLoading () {
                return this.$store.getters['loading/isLoading'];
            },
        },
        created() {
            this.loadProfile();
        },
        beforeRouteUpdate (to, from, next) {
            // обрабатываем изменение параметров маршрута...
            // не забываем вызвать next()
            this.loadProfile();
            next();
        },
        methods: {
            loadProfile() {
                this.profile = null;

                this.$store.dispatch('loading/start', 'Загрузка формы создания персонажа...', { root: true });

                this.axios.get('/api/rpg/profile/' + this.currentGame.key + '/create')
                    .then((response) => {
                        // context.dispatch('initUser', {
                        //     user: response.data
                        // });
                        this.profile = {};
                        this.species = response.data.species;
                        this.factions = response.data.factions;
                        this.genders = response.data.genders;
                        this.positions = response.data.positions;
                        this.$store.dispatch('loading/stop', null, { root: true });
                    }).catch((error) => {
                    let message = error.response.data.error ? error.response.data.error : error.response.data;
                    this.$store.dispatch('loading/error', message);
                    this.$store.dispatch('loading/stop', null);
                    // context.rootState.router.push('login');
                });
            },

            submit: function (profile) {
                this.errors = null;
                this.$store.dispatch('loading/start', 'Создание персонажа...', { root: true });
                this.axios.post('/api/rpg/profile/' + this.currentGame.key + '/create', profile).then( (response) => {
                    this.$store.dispatch('loading/stop', null);
                    // Устанавливаем инфу о персонаже. Тем самым добавится новый
                    this.$store.dispatch('rpg/setCharacterData', response.data.profile);
                    // Выбираем этого персонажа.
                    this.$store.dispatch('rpg/setCharacter', response.data.profile.key);
                    this.$store.dispatch('message/success', response.data.message);
                    this.$router.push({ name: 'profile.index' });
                }).catch((error) => {
                    //console.error(error);
                    this.errors = error.response.data.errors;
                    this.$store.dispatch('loading/stop', null);
                });
            },
        }
    }
</script>

<style scoped>

</style>
